import utils from 'src/components/Organisms/Form/utils'
import { ConfigCompanyDetails } from '../../CompanyDetails/types'
import DropdownWrapper from 'src/views/Atoms/CountryDropdown/DropdownWrapper'

const config = ({ countries }: ConfigCompanyDetails) => utils.injectTranslation({
  id: 'AddShareholderDetailsForm',
  path: 'onboarding.forms.CorporateAccount.CompanyDirectorsForm.inputs',
  content: [
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: '1.5fr 1fr',
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'nameOfDirector',
            required: true,
            maxlength: 100,
          },
        },
        {
          componentType: 'date',
          transformType: 'date',
          submitValidation: 'date',
          props: {
            name: 'dateOfBirth',
            noFuture: true,
            required: true,
            dontClearValue: true,
          },
        },
      ],
    },
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: '1fr 1fr',
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'residentialAddress',
            required: true,
            isTextarea: true,
            textAreaHeight: '48px',
            textAreaPointerEvents: 'auto',
            resize: 'none',
            maxlength: 100,
          },
        },
      ],
    },
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: '1fr 1fr 1fr',
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'directorCity',
            required: true,
            maxlength: 100,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'directorPostCode',
            required: true,
            maxlength: 100,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'directorCountry',
            required: true,
          },
          // @ts-ignore
          custom: props => DropdownWrapper({
            options: countries,
            name: 'directorCountry',
            label: 'onboarding.forms.CorporateAccount.CompanyDirectorsForm.inputs.directorCountry.label',
            placeholder: 'onboarding.forms.CorporateAccount.CompanyDirectorsForm.inputs.directorCountry.placeholder',
            required: true,
            bgTransparent: true,
            filter: true,
            ...props
          })
        },
      ],
    },
  ],
})

export default config
